import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/pro-solid-svg-icons";
import "./FilterDropdownButton.scss";

interface IProps {
    name: string;
    // if this text is translation key to be added along with the filterNameDisplay
    translationText: string;
    // to directly display the filterNameDisplay without any translation
    noTranslation?: boolean;
    count: number;
    filterNameDisplay: string;
    // if filterNameDisplay includes the translation key in itslef only
    directTranslationOnFilterName?: boolean;
}

const FilterDropdownButton = (props: IProps) => {
    const { t } = useTranslation();

    return (
        <>
            <div className="inDisplayFilterButton">
                <div className="inDisplayFilterButtonText">{t(`${props.translationText}${props.name}`)}</div>
                <div className="inDisplayFilterNum">
                    <div className="inDisplayFilterNumText">
                        {!props.directTranslationOnFilterName &&
                            (props.noTranslation
                                ? props.filterNameDisplay
                                : t(`${props.translationText}${props.filterNameDisplay}`))}
                        {props.directTranslationOnFilterName && t(props.filterNameDisplay)}
                    </div>
                    {props.count > 1 && <div className="countDiv">{`+${props.count - 1}`}</div>}
                </div>
            </div>
            <FontAwesomeIcon icon={faChevronDown} className="filterDropdownActionButton" />
        </>
    );
};

export default FilterDropdownButton;
